<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">시험문항 추가</h2>
					<a class="close" @click="config.show=false">×</a>
				</div>
				<div class="modal-body p-15" style="min-height: 1px;">
					<div class="input-group pull-left clearfix">
						<select class="form-control-sm m-b-0 round pull-left m-r-5" type="text" v-model="selectedCategory1">
							<option value="0">시험 대분류</option>
							<option v-for="(item,idx) in categories_1st" :item="item" :index="idx" :key="'exam-categories-1-options-'+idx+hash(item)" :value="item.examCategoryId">{{item.name}}</option>
						</select>
						<select class="form-control-sm m-b-0 round pull-left m-r-5" type="text" v-model="selectedCategory2">
							<option value="0">시험 중분류</option>
							<option v-for="(item,idx) in categories_2nd" :item="item" :index="idx" :key="'exam-categories-1-options-'+idx+hash(item)" :value="item.examCategoryId">{{item.name}}</option>
						</select>
						<select class="form-control-sm m-b-0 round pull-left" type="text" v-model="selectedCategory3">
							<option value="0">시험 소분류</option>
							<option v-for="(item,idx) in categories_3rd" :item="item" :index="idx" :key="'exam-categories-1-options-'+idx+hash(item)" :value="item.examCategoryId">{{item.name}}</option>
						</select>
					</div>
					<div class="search-box pull-right w260">
						<input id="search" class="form-control-sm round full-width m-b-0" type="text" v-model="keyword">
						<label for="search" style="width: 30px;height: 30px;background-size: 20px;">검색</label>
					</div>
					<div class="clearfix"></div>
					<table class="table2 table-hover table-condensed m-t-10 text-center">
						<thead>
							<tr class="bg-lightgray">
								<th>
									<input id="table-allcheck" ref="checkAll" class="checkbox" type="checkbox" @click="checkAll">
									<label for="table-allcheck">체크버튼</label>
								</th>
								<th>답안유형</th>
								<th>문항</th>
							</tr>
						</thead>
						<tbody v-for="(item, idx) in list" :item="item" :index="idx" :key="'exam-append-item-list-'+idx+hash(item)">
							<tr class="margin">
								<td colspan="3"></td>
							</tr>
							<tr>
								<td>
									<input :id="'table-check'+idx" class="checkbox" type="checkbox" v-model="item.checked_" @change="checkOne(item)">
									<label :for="'table-check'+idx">체크버튼</label>
								</td>
								<td>{{item.type}}</td>
								<td>
									{{item.itemName}}
								</td>
							</tr>
						</tbody>
					</table>
					<ctrl-pagination
						:currentPage="offset / pageSize + 1"
						:pageSize="pageSize"
						:totalCount="totalCount"
						:key="hash({pageSize, offset, totalCount})"
						@pageChanged="onPageChanged"
					></ctrl-pagination>
				</div>
				<div class="modal-footer p-15 m-t-30 clearfix">
					<button class="btn btn-blue round full-width" type="button" @click="append">선택 추가</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from 'axios'
import server from '../statics/server.js'
import CtrlPagination from "../components/CtrlPagination.vue";

export default {
	name: "ModalExamAppend",
	components: {
		CtrlPagination
	},

	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object
	},

	data: function() {
		return {
			// 검색 조건
			offset: 0,
			keyword: "",
			orderBy: "REG_DATE DESC",
			pageSize: 10,
			totalCount: 0,

			selectedCategory1: 0,
			selectedCategory2: 0,
			selectedCategory3: 0,
			categories_1st: [],
			categories_2nd: [],
			categories_3rd: [],
			list: [],
		}
	},
	mounted: function() {
		// 시험문항 카테고리 목록을 얻는다.
		axios.post(server.addr()+server.api.EXAM_CATEGORY, {parentsId:0}).then( (response) => {
			this.categories_1st = response.data.list;
		});
		this.refresh();
	},
	watch: {
		selectedCategory1: function(newValue) {
			this.selectedCategory2 = 0;
			this.selectedCategory3 = 0;
			this.categories_3rd = [];
			axios.post(server.addr()+server.api.EXAM_CATEGORY, {parentsId:newValue}).then( (response) => {
				this.categories_2nd = response.data.list;
			})
			this.selectedCategory1 = newValue;
			this.refresh();
		},
		selectedCategory2: function(newValue) {
			this.selectedCategory3 = 0;
			axios.post(server.addr()+server.api.EXAM_CATEGORY, {parentsId:newValue}).then( (response) => {
				this.categories_3rd = response.data.list;
			})
			this.selectedCategory2 = newValue;
			this.refresh();
		},
		selectedCategory3: function(newValue) {
			this.selectedCategory3 = newValue;
			this.refresh();
		}
	},
	methods: {
		refresh: function() {
			let selectedCategory = 0;
			if(this.selectedCategory3 && this.selectedCategory3!=0) selectedCategory = this.selectedCategory3;
			else if(this.selectedCategory2 && this.selectedCategory2!=0) selectedCategory = this.selectedCategory2;
			else if(this.selectedCategory1 && this.selectedCategory1!=0) selectedCategory = this.selectedCategory1;
			axios.post(server.addr()+server.api.EXAM_ITEM, {examCategoryId:selectedCategory, keyword:this.keyword, parentsId:0, offset:this.offset, pageSize:this.pageSize}).then( (response) => {
				this.totalCount = parseInt(response.data.filtered);
				this.list = response.data.list.map(l=>{l.checked_=false;return l});
			});
		},
		// 페이지 이동
		onPageChanged: function(page) {
			this.offset = (page - 1) * this.pageSize;
			this.refresh();
		},
		checkOne: function(item) {
			if(item.checked_) {
				if(this.list.find(l=>!l.checked_)) {
					this.$refs.checkAll.checked = false;
				} else {
					this.$refs.checkAll.checked = true;
				}
			} else {
				this.$refs.checkAll.checked = false;
			}
		},
		checkAll: function() {
			if(this.list.find(l=>!l.checked_)) {
				this.list.forEach(l=>l.checked_=true);
			} else {
				this.list.forEach(l=>l.checked_=false)
			}
		},
		append: function() {
			if(this.list.filter(l=>l.checked_).length==0) {
				this.$emit('alert', "시험에 추가할 문항을 선택하세요.");
				return;
			}
			this.$emit('append', this.list.filter(l=>l.checked_));
			this.config.show = false;
		}
	}

}
</script>
